<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div class="tab">
        <div :class="{ active: currentTab == 0 }" @click="showContent(0)">Thông tin chung</div>
        <div :class="{ active: currentTab == 1 , 'hide-tab' : hideTab == 1}" @click="showContent(1)">Khác</div>
      </div>
      <div :class="{ content : true, active: currentTab == 0 }">
        <div class="">
          <div class="f-grid" style="margin: 0px 10px 0px 10px;">
            <div class="f-grid-col">
              <div class="mt-2">
                <span class="title-css">THÔNG TIN ĐĂNG NHẬP</span>
              </div>
              <div class="mt-2" v-if="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN">
                <label :class="{'txt-right' : true, 'required' : is_required}">Công ty</label>
                <DropdownScrollable 
                  placeholder="Chọn công ty" 
                  cusClass="m-0 cs-width" 
                  :limit="company_obj.limit" 
                  :loading="company_obj.loading" 
                  :show="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN" 
                  v-model="company" 
                  :options="company_obj.items" 
                  :total="company_obj.total" 
                  @keyup="emitEvent" 
                  @offset="changeOffset" 
                  :disabled="mode=='edit'" 
                  @scroll="emitEvent"
                />
                <input class="input-group input_tmp_validator" id="company" />
              </div>
              <div class="mt-2">
                <label class="txt-right required">Tên hiển thị</label>
                <InputText v-model="fullname" type="text" class="cs-input input-text-box" placeholder="Nhập" id="fullname"/>
              </div>
              <div class="mt-2">
                <label class="txt-right required">Tên đăng nhập / CCCD</label>
                <InputText :disabled="mode=='edit'" v-model="username" type="text" class="cs-input input-text-box" placeholder="Nhập" id="username"/>
                <span style="color:#8f8c8c">Bạn có thể nhập mã nhân viên thay cho tên đăng nhập</span>
              </div>
              <div class="mt-2">
                <label class="txt-right">Ngày sinh</label>
                <div class="p-inputgroup">
                  <Calendar v-model="birthday_1" dateFormat="dd/mm/yy" :showIcon="true" :manualInput="false" :showButtonBar="true" appendTo="body" placeholder="DD/MM/YYYY" yearNavigator monthNavigator :yearRange="yearRange"/>
                </div>
                <input class="input_tmp_validator_r" id="birthday_add" />
              </div>
              <div class="mt-2">
                <label class="txt-right">Email</label>
                <InputText v-model="email" type="text" class="cs-input input-text-box" placeholder="mail@example.com" id="email"/>
              </div>
              <div class="mt-2">
                <label class="txt-right">Số điện thoại</label>
                <InputText v-model="phone" type="text" class="cs-input input-text-box" placeholder="Nhập" id="phone"/>
              </div>
              <div class="mt-2">
                <label class="txt-right" :class="{ required: mode == 'add' }">Mật khẩu đăng nhập</label>
                <CPassword v-model="password" type="password" class="cs-input input-text-box" :toggleMask="true" showIcon="pi pi-eye-slash" hideIcon="pi pi-eye"/>
                <input class="input-group input_tmp_validator" id="password" />
              </div>
              <div class="mt-2">
                <label class="txt-right required">CCCD</label>
                <InputText v-model="id_card" type="text" class="cs-input input-text-box" placeholder="Nhập" id="id_card"/>
              </div>
              <div class="mt-2">
                <Checkbox v-model="active" :binary="true" /><span>Hoạt động</span>
              </div>
            </div>
            <div class="f-grid-col">
              <div class="mt-2">
                <span class="title-css">LOẠI TÀI KHOẢN</span>
              </div>
              <div class="mt-2" v-show="mode == 'edit'">
                <label class="txt-right">Nhóm quyền</label>
                <InputText :disabled="true" v-model="group_permission" type="text" class="cs-input input-text-box" placeholder="Nhóm quyền"/>
              </div>
              <div class="mt-2 radio-group" v-show="mode == 'add' && show_type_company==true">
                <div style="display: flex;">
                  <input type="radio" value="internal" v-model="type_company" @change="changeType"><span style="margin-left: 5px;"> Nội bộ</span>
                </div>
                <div style="display: flex;">
                  <input type="radio" value="contractor" v-model="type_company" @change="changeType"><span style="margin-left: 5px;"> Nhà thầu</span>
                </div>
              </div>
              <div class="mt-2" v-show="mode == 'edit'">
                <label class="txt-right required">Loại tài khoản</label>
                <InputText :disabled="mode == 'edit'" v-model="text_type" type="text" class="cs-input input-text-box"/>
              </div>
              
              <div class="mt-2">
                <label class="txt-right required">Quyền (role)</label>
                <Dropdown v-model="role_company" :options="company_roles" optionLabel="label" placeholder="Chọn quyền (role)"/>
                <input class="input-group input_tmp_validator_r" id="role_company_add" />
              </div>
              <div class="mt-2" v-if="type_company == 'internal'">
                <div>
                  <label class="txt-right required">Bộ phận</label>
                  <DropdownScrollable
                    placeholder="Chọn bộ phận"
                    :showClear="false"
                    cusClass="m-0 cs-width"
                    :multiple="false"
                    :limit="department_obj.limit"
                    :loading="department_obj.loading"
                    v-model="department_sel"
                    :options="department_obj.items"
                    :total="department_obj.total"
                    @keyup="emitEventDepartment"
                    @scroll="emitEventDepartment"
                    @offset="changeOffsetDepartment"
                  />
                  <input class="input_tmp_validator_r" id="department" />
                </div>
                <div>
                  <label v-for="(item, index) in departments" :key="index" class="cus-tags">
                    <span class="cs-tag">
                      {{item.name}}
                    </span>
                    <i class="fas fa-times cs-icon" v-on:click="removeDepartments(index)"></i>
                  </label>
                </div>
                <div>
                  <label class="txt-right required">Chức vụ</label>
                  <DropdownScrollable
                    placeholder="Chọn chức vụ"
                    :showClear="false"
                    cusClass="m-0 cs-width"
                    :multiple="false"
                    :limit="position_obj.limit"
                    :loading="position_obj.loading"
                    v-model="position_sel"
                    :options="position_obj.items"
                    :total="position_obj.total"
                    @keyup="emitEventPosition"
                    @scroll="emitEventPosition"
                    @offset="changeOffsetPosition"
                  />
                  <input class="input_tmp_validator_r" id="position" />
                </div>
                <div>
                  <label v-for="(item, index) in positions" :key="index" class="cus-tags">
                    <span class="cs-tag">
                      {{item.name}}
                    </span>
                    <i class="fas fa-times cs-icon" v-on:click="removePositions(index)"></i>
                  </label>
                </div>
              </div>
              <div class="mt-2" v-if="type_company == 'contractor'">
                <div>
                  <label class="txt-right required">Nhà thầu</label>
                  <DropdownScrollable
                    placeholder="Chọn nhà thầu"
                    :showClear="true"
                    cusClass="m-0 cs-width"
                    defaultLabel="label"
                    :limit="contractor_obj.limit"
                    :loading="contractor_obj.loading"
                    v-model="selcontractor"
                    :options="contractor_obj.items"
                    :total="contractor_obj.total"
                    @keyup="emitEventContractor"
      
                    @scroll="emitEventContractor"
                    :disabled="disable_select_contractor"
                  />
                  <input class="input_tmp_validator_r" id="contractor_add" />
                </div><div>
                  <label class="txt-right">Công việc</label>
                  <div class="p-inputgroup">
                    <InputText v-model="work" type="text" class="cs-input input-text-box" placeholder="Nhập" id="work"/>
                  </div>
                </div>
                <div>
                  <label class="txt-right">Ngày đào tạo</label>
                  <div class="p-inputgroup">
                    <Calendar v-model="educated_date" dateFormat="dd/mm/yy" :showIcon="true" :manualInput="false" :showButtonBar="true" appendTo="body" placeholder="DD/MM/YYYY" yearNavigator monthNavigator :yearRange="yearRange"/>
                  </div>
                </div>
                <div v-if="show_educated_work_status" v-show="mode === 'edit'">
                  <label class="txt-right">Trạng thái đào tạo</label>
                  <div class="p-inputgroup">
                    <InputText v-model="educated_status" type="text" class="cs-input input-text-box" placeholder="Nhập" id="educated_status" disabled/>
                  </div>
                </div>
                <div v-if="show_educated_work_status" v-show="mode === 'edit'">
                  <label class="txt-right">Trạng thái làm việc</label>
                  <div class="p-inputgroup">
                    <InputText v-model="work_status" type="text" class="cs-input input-text-box" placeholder="Nhập" id="work_status" disabled/>
                  </div>
                </div>
              </div>
              <div class="mt-2">
                <label class="txt-right">Hình đại diện</label>
                <input class="input_tmp_validator" id="images">
                <div class="cus-text">Kích thước đề xuất: 500x500px - Dung lượng tối đa: 50 MB</div>
                <div class="cus-text">Định dạng file:: JPG, JPEG, PNG, GIF (không phải ảnh động).</div>
                <input class="p-inputtext p-component cs-input" style="background-color: #EEEEEE;" accept="image/*" name="images[]" type="file" @change="onFileSelect"/>
                <div class="box-images mt-3 cs-input"  v-if="images && images.length">
                  <div class="item-img" v-for="(item, index) in images" :key="index" >
                    <div class="button-clear" @click="onFileClear(index)"><img src="../../../assets/ic_clear.svg"/></div>
                    <img :src="item.objectURL" width="80" height="80"/>
                  </div>
                </div>
              </div> 
            </div>
          </div>
          <div class="f-grid" style="margin: 10px 10px 0px 10px;" v-show="type_company == 'contractor'">
            <div class="f-grid-col">
              <div class="mt-2">
                <span class="title-css">HỒ SƠ NHÂN SỰ</span>
              </div>
            </div>
          </div>
          <div class="f-grid" style="margin: 0px 10px 0px 10px;" v-show="type_company == 'contractor'">
            <div class="f-grid-col">
              <div class="mt-3">
                <table id="tb_level">
                  <tr>
                    <th style="width: 50px;">STT</th>
                    <th style="">Tên hồ sơ</th>
                    <th style="width: 260px;">Danh sách file</th>
                    <th style="width: 90px;">Hiệu lực đến</th>
                    <th style="width: 90px">Hành động</th>
                  </tr>
                  <tr v-for="(item, index) in list_profile" :key="index">
                    <td>{{index+1}}</td>
                    <td>{{item.name}}</td>
                    <td>
                      <div v-if="item.files && item.files.length > 0" class="profile-file-list">
                        <div v-for="(file, fileIndex) in item.files" :key="fileIndex" class="profile-file-row">
                          <a href="#" class="profile-file-link" @click.prevent="viewFile(file)">{{file.name}}</a>
                          <Button icon="pi pi-download" class="p-button-download p-button-link" @click="downloadFile(file)"/>
                        </div>
                      </div>
                    </td>
                    <td>{{item.expiration_date_text}}</td>
                    <td style="text-align: center;" >
                      <Button
                        @click="ShowUpload(index)"
                        icon="pi pi-upload"
                        class="button-box p-button-add"
                      >
                      </Button>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>

          <div class="f-grid" style="margin: 10px 10px 0px 10px;" v-show="list_course.length > 0">
            <div class="f-grid-col">
              <div class="mt-2">
                <span class="title-css">THÔNG TIN KHÓA ĐÀO TẠO</span>
              </div>
            </div>
          </div>
          <div class="f-grid" style="margin: 0px 10px 0px 10px;" v-show="list_course.length > 0">
            <div class="f-grid-col">
              <div class="mt-3">
                <table id="tb_course">
                  <tr>
                    <th style="width: 50px;">STT</th>
                    <th style="">Khóa đào tạo</th>
                    <th style="width: 80px;">Loại</th>
                    <th style="">SRA cuối cần khóa này</th>
                    <th style="width: 80px;">Kết quả</th>
                    <th style="width:120px">Hiệu lực đến</th>
                  </tr>
                  <tr v-for="(item, index) in list_course" :key="index">
                    <td>{{index+1}}</td>
                    <td>{{item.course_name}}</td>
                    <td>{{item.type_text}}</td>
                    <td>{{item.sra_name}}</td>
                    <td>{{item.kq_text}}</td>
                    <td>{{item.time_exp}}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div :class="{ content : true, active: currentTab == 1 }">
        <div class="">
          <!-- Thông tin khác liên kiến với HSE soft -->
          <div class="f-grid" style="margin: 0px 10px 0px 10px;">
            <div class="f-grid-col">
              <div class="mt-2">
                <label class="txt-right">Quản lý trực tiếp</label>
                <DropdownScrollable
                  placeholder="Chọn"
                  :showClear="true"
                  cusClass="m-0 cs-width"
                  :limit="users1_obj.limit"
                  :loading="users1_obj.loading"
                  v-model="selusers1"
                  :options="users1_obj.items"
                  :total="users1_obj.total"
                  @keyup="emitEventUsers1"
                  @offset="changeOffsetUsers1"
                  @scroll="emitEventUsers1"
                />
                <input class="input_tmp_validator_r" id="selusers1_add" />
              </div>
              <div class="mt-2">
                <label class="txt-right">Nhân viên an toàn nhóm</label>
                <Dropdown class="p-col-width" v-model="safety_staff_group_id" :options="safety_staff_group_list" optionValue="id" optionLabel="name" :showClear="true" placeholder="Chọn"/>
              </div>
            </div>
            <div class="f-grid-col">
              <!-- <div class="mt-2">
                
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <Toolbar class="fixed-bottom-toolbar">
        <template slot="right">
          <Button
            :label="$constants.TEXT_BUTTON.BACK"
            @click="backToList()"
            class="p-button-warning return-style-button" />
          <Button
            v-if="mode == 'edit'"
            :label="$constants.TEXT_BUTTON.EDIT"
            @click="saveData()"
            class="p-button-success main-style-button" />
          <Button
            v-else
            :label="$constants.TEXT_BUTTON.ADD"
            @click="saveData()"
            class="p-button-success main-style-button" />
        </template>
      </Toolbar>
      <Dialog header="Tải tệp" :visible.sync="showEditDialog" :modal="true" :contentStyle="{padding: '20px', overflow: 'visible', maxHeight: '80vh'}">
        <div style="padding-top: 0px;width: 400px; min-width: 400px;">
          <div v-if="profile_info">    
            <label class="txt-left">Hiệu lực từ</label>
            <Calendar v-model="profile_info.expiration_from" dateFormat="dd/mm/yy" :showIcon="true" :manualInput="false" :showButtonBar="true" placeholder="DD/MM/YYYY"/>
            <label class="txt-left">Hiệu lực đến</label>
            <Calendar v-model="profile_info.expiration_date" dateFormat="dd/mm/yy" :showIcon="true" :manualInput="false" :showButtonBar="true" placeholder="DD/MM/YYYY"/>
          </div>
          <input class="input_tmp_validator" id="files">
          <div class="cus-text">Dung lượng tối đa: 50 MB</div>
          <div class="cus-text">Định dạng file: docx, doc, xlsx, pptx, pdf, png, jpg, jpeg.</div>
          <input class="p-inputtext p-component text-box-a" multiple style="background-color: #EEEEEE;" accept=".docx, .doc, .xlsx, .xls, .pptx, .pdf, .png, .jpg, .jpeg" name="files[]" type="file" @change="onFileSelect2"/>
          <div v-if="loading" class="loading-overlay">
            <div class="spinner"></div>
            <p>Đang tải lên...</p>
          </div>
          <div class="box-images text-box-a profile-file-list" v-if="profile_info && profile_info.files && profile_info.files.length > 0" style="max-height: 200px;overflow-y: auto;">
            <div class="profile-file-row" v-for="(item, index) in profile_info.files" :key="index" >
              <a href="#" class="profile-file-link" @click.prevent="viewFile(item)">{{item.name}}</a>
              <Button icon="pi pi-download" class="p-button-download p-button-link" @click="downloadFile(item)"/>
              <Button icon="pi pi-trash" class="p-button-secondary p-button-link text-danger" @click="onFileClear2(index)"/>
            </div>
          </div>
        </div>
        <template #footer>
          <Button label="Hủy" @click="showEditDialog = false" icon="pi pi-times" class="p-button-cancel-2"/>
          <Button type="button" label="Xác nhận" @click="EditData()" icon="pi pi-check" class="" />
        </template>
      </Dialog>
    </div>
  </form>
</template>

<script>
// import DataServices from "@/core/DataServices";
import moment from "moment-timezone";
import Password from "@/components/Password";
import ApiRepository from "@/core/ApiRepository";
import DropdownScrollable from '@/components/DropdownScrollable_v2';
import GetConstants from './../../../core/Constants';
var Constants = GetConstants.getConstans();
export default {
  components: {
    DropdownScrollable,
    CPassword: Password
  },
  props: {
    mode: String,
    model: Object,
    users: Array,
    company_id: String
  },
  data() {
    return {
      disable_select_contractor : false,
      is_required : true,
      type_company : 'internal',
      text_type : 'Admin',
      show_type_company : true,
      company_roles : [
        {value : 'admin', label : 'Admin'},
        {value : 'staff', label : 'Nhân viên'}
      ],
      role_company : null,
      name: "",
      username: "",
      fullname: "",
      phone: "",
      email: "",
      active: true,
      positions: [],
      departments: [],
      images: [],
      logo: [],
      password: "",
      maxFilesProfile: 100,
      maxFiles: 1,
      maxFileSize: 10485760*5,
      imagesDeletes: [],
      company: {},
      company_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      position_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      department_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      contractor_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      selcontractor : null,
      uid: null,
      loadKey: 0,
      group_permission: null,
      list_profile : [
        // {
        //   id : 1,
        //   name : "Giấy khám sức khoẻ",
        //   files : []
        // },
        // {
        //   id : 2,
        //   name : "Bảo hiểm tai nạn",
        //   files : []
        // },
      ],
      profile_info : null,
      showEditDialog : false,
      index_update : -1,
      filesDeletes : [],
      edit_id : null,
      filesDeletes2 : [],
      filesDeletes2_tmp : [],
      object_id : null,
      list_course : [],
      id_card : "",
      department_sel : null,
      position_sel : null,
      birthday : null,
      work : null,
      educated_status : null,
      work_status : null,
      educated_date : null,
      birthday_1 : null,
      loading : false,
      yearRange : '1950:' + new Date().getFullYear(),
      show_educated_work_status : false,
      currentTab : 0,
      hideTab : 1,
      users1_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      selusers1 : null,
      safety_staff_group_list : [],
      safety_staff_group_id : null,
    };
  },
  async mounted() {
    await this.getListCompany();
    await this.getListPosition();
    await this.SafetyStaffGroup();
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.group_permission = this.model?.group_permission;
      this.fullname = this.model.fullname;
      this.phone = this.model.phone;
      this.email = this.model.email;
      this.username = this.model.username;
      this.id_card = this.model.id_card;
      this.name = this.model.name;
      this.type_company = this.model.type_company;
      this.work = this.model.work;
      if (this.model.birthday) {
        this.birthday_1 = new Date(this.model.birthday);
      }

      console.log("this.model.educated_status", this.model.educated_status);
      if (this.model.educated_status) {
        if(this.model.educated_status == 'not_expired'){
          this.educated_status = 'Chưa hết hạn'
        }else if(this.model.educated_status == 'expired'){
          this.educated_status = 'Đã hết hạn'
        }else if (this.model.educated_status == 'not_attended'){
          this.educated_status = 'Chưa đào tạo'
        }
      }

      if (this.educated_status === "not_expired") {
        let valid_file = true
        for (let i = 0; i < this.model.paper_files.length; i++) {
          if (this.model.paper_files[i].status === 'expired') {
            valid_file = false
            break;
          }
        }
        if (valid_file) {
          this.work_status = "Đủ điều kiện";
        } else {
          this.work_status = "Không đủ điều kiện";
        }
      } else {
        this.work_status = "Không đủ điều kiện";
      }

      if(this.model.role_company == 'admin'){
        this.role_company = {
          value : 'admin',
          label : 'Admin',
        }
        this.show_educated_work_status = false
      }else{
        this.role_company = {
          value : 'staff',
          label : 'Nhân viên',
        }
        this.show_educated_work_status = true
      }
      if(this.model.type_company == 'contractor'){
        this.text_type = 'Nhà thầu'
        this.selcontractor = {
          id : this.model.contractor_id,
          label : this.model.contractor_filter
        }
      }else{
        this.text_type = 'Nội bộ'
        var sortedUsersPosition = this.sortByOrdinalAsc(this.model.users_position);
        var sortedUsersDepartment = this.sortByOrdinalAsc(this.model.users_department);
        // console.log("sortedUsersPosition", sortedUsersPosition);
        // console.log("sortedUsersDepartment", sortedUsersDepartment);
        this.positions = sortedUsersPosition.map(m => {return {id: m.position_id, name: m.position_name}});
        this.departments = sortedUsersDepartment.map(m => {return {id: m.department_id, name: m.department_name}});
      }
      this.active = this.model.active;
      this.company_id = this.model.company_id;
      this.company = {id: this.company_id};
      if (this.$route.params.id !== undefined) this.uid = this.$route.params.id;
      if (!this.$commonFuction.isEmpty(this.model.list_files) && this.model.list_files.length > 0) {
        let url = this.model.list_files[0].file.url
        let split = url.split('/')
        let fileName = split[split.length - 1]
        let obj = {'name': fileName, 'file': '', 'objectURL': url,type:'old_edit'}//type:'old_edit' nếu gặp type này ko update avatar
        this.images.push(obj);
      }
      this.getListCourse(this.$route.params.id);

      //thêm khác
      if (this.model.manager){
        this.selusers1 = {
          id : this.model.manager.id,
          name : this.model.manager.name,
          fullname: this.model.manager.fullname,
          created_at: this.model.manager.created_at,
          username: this.model.manager.username,
        }
      }
      if (this.model.safety_staff_group){
        this.safety_staff_group_id = this.model.safety_staff_group.id ?? null
      }
    }
    console.log("this.mode", this.mode);
    console.log("this.$store.getters.typeCompany", this.$store.getters.typeCompany);
    if(this.mode == 'add'){
      if(this.$store.getters.typeCompany == 'contractor'){
        this.show_type_company = false
        this.type_company = 'contractor'
        this.text_type = 'Nhà thầu'
      }else{
        this.show_type_company = true
      }
    }
    // await this.getListDocumentFileAll();
    
  },
  watch: {
    async "company_id"() {
      if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
        this.company = {id: this.company_id};
        console.log("this.companythis.companythis.company", this.company);
        await this.getListDepartment();
        await this.getListPosition();
        await this.getListContractor();
      }
    },
    async "$store.getters.company_id"() {
      if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
        this.$set(this,'company_id', (this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN) ? this.$store.getters?.company_id : null);
        this.company = {id: this.company_id};
        console.log("this.companythis.companythis.company", this.company);
        await this.getListDepartment();
        await this.getListPosition();
        await this.getListContractor();
      }
    },
    async "company"() {
      this.department_sel = null
      this.position_sel = null
      if(this.mode == 'add'){
        this.selusers1 = null
        this.selcontractor = null
        this.educated_status = null
        this.educated_date = null
        this.users1_obj = {
          offset: 0,
          filters: {},
          limit: 20,
          items: [],
          total: 0,
          loading: false
        }
      }
      await this.getListDepartment();
      await this.getListPosition();
      await this.getListContractor();
      await this.getListDocumentFileAll();
      if (this.mode == "edit" && this.loadKey == 0) {
        this.loadKey++;
      } else {
        this.departments = [];
        this.positions = [];
        this.selcontractor = null
        this.educated_status = null
        this.educated_date = null
      }
      // console.log(this.departments);
      if(this.contractor_obj.items.length > 0){
        if(this.mode == 'add' && this.$store.getters.typeCompany == 'contractor'){
          this.selcontractor = this.contractor_obj.items[0]
          this.disable_select_contractor = true
        }
      }
      this.LoadModuleUser();
      await this.getListUsers1();
    },
    async "department_sel"() {
      if(this.$commonFuction.isEmptyObject(this.department_sel)){
        return
      }else{
        var check_exist = false;
        for (let i = 0; i < this.departments.length; i++) {
          if(this.departments[i].id == this.department_sel.id){
            check_exist = true;
            break;
          }
        }
        if(check_exist == false){
          this.departments.push(this.department_sel)
        }
        this.department_sel = null
      }
    },
    async "position_sel"() {
      if(this.$commonFuction.isEmptyObject(this.position_sel)){
        return
      }else{
        var check_exist = false;
        for (let i = 0; i < this.positions.length; i++) {
          if(this.positions[i].id == this.position_sel.id){
            check_exist = true;
            break;
          }
        }
        if(check_exist == false){
          this.positions.push(this.position_sel)
        }
        this.position_sel = null
      }
    },
    async "role_company"() {
      console.log("this.role_company", this.role_company);
      if (this.role_company && this.role_company.value == 'admin') {
        this.show_educated_work_status = false
      } else {
        this.show_educated_work_status = true
      }
    }
  },
  methods: {
    emitEvent(keyword) {
      this.$delete(this.company_obj.filters, 'name');
      if (keyword) {
        this.company_obj.filters.name = keyword;
      }
      this.getListCompany();
    },
    changeOffset(value) {
      this.company_obj.offset = value;
    },
    async getListCompany() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.company_obj.loading = true;
        await ApiRepository.post("/_api/company/options", {filters: this.company_obj.filters, limit: this.company_obj.limit, offset: this.company_obj.offset}, {headers}).then((res) => {
          if (this.company_obj.offset > 0 ) {
            this.company_obj.items.push(...res.data.data.company);
          } else{
            this.company_obj.items = res.data.data.company;
          }
          this.company_obj.total = res.data.data.total;
          this.company_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.company_obj.loading = false;
        })
      }
    },
    emitEventDepartment(keyword) {
      // console.log(keyword);
      this.$delete(this.department_obj.filters, 'name');
      if (keyword) {
        this.department_obj.filters.name = keyword;
      }
      this.getListDepartment();
    },
    changeOffsetDepartment(value) {
      this.department_obj.offset = value;
    },
    async getListDepartment() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.department_obj.loading = true;
        await ApiRepository.post("/_api/department/options", {filters: this.department_obj.filters, limit: this.department_obj.limit, offset: this.department_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
            if (this.department_obj.offset > 0 ) {
              this.department_obj.items.push(...res.data.data.department);
            } else{
              this.department_obj.items = res.data.data.department;
            }
            this.department_obj.total = res.data.data.count;
            this.department_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.department_obj.loading = false;
        })
      }
    },
    emitEventContractor(keyword) {
      console.log(keyword);
      this.$delete(this.contractor_obj.filters, 'filter_txt');
      if (keyword) {
        this.contractor_obj.filters.filter_txt = keyword;
      }
      this.getListContractor();
    },
    changeOffsetContractor(value) {
      this.contractor_obj.offset = value;
    },
    async getListContractor() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        this.contractor = null,
        this.contractor_obj = {
          offset: 0,
          filters: {},
          limit: 20,
          items: [],
          total: 0,
          loading: false
        }
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.contractor_obj.loading = true;
        await ApiRepository.post("/_api/contractor/options", {filters: this.contractor_obj.filters, limit: this.contractor_obj.limit, offset: this.contractor_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
            if (this.contractor_obj.offset > 0 ) {
              this.contractor_obj.items.push(...res.data.data.contractor);
            } else{
              this.contractor_obj.items = res.data.data.contractor;
            }
            this.contractor_obj.total = res.data.data.count;
            this.contractor_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.contractor_obj.loading = false;
        })
      }
    },
    emitEventPosition(keyword) {
      this.$delete(this.position_obj.filters, 'name');
      if (keyword) {
        this.position_obj.filters.name = keyword;
      }
      this.getListPosition();
    },
    changeOffsetPosition(value) {
      this.position_obj.offset = value;
    },
    async getListPosition() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      this.position_obj.filters = {company_id: this.company.id};
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.position_obj.loading = true;
        await ApiRepository.post("/_api/position/options", {filters: this.position_obj.filters, limit: this.position_obj.limit, offset: this.position_obj.offset}, {headers}).then((res) => {
            if (this.position_obj.offset > 0 ) {
              this.position_obj.items.push(...res.data.data.position);
            } else{
              this.position_obj.items = res.data.data.position;
            }
            this.position_obj.total = res.data.data.total;
            this.position_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.position_obj.loading = false;
        })
      }
    },
    backToList() {
      this.$emit("back");
    },
    async validateData() {
      this.validationErrors = {};
      if (this.mode == "add") {
        if (this.$store.getters.type == this.$constants.TYPE_USER.SUPPER_ADMIN) {
          let company_add = document.getElementById("company");
          if (
            this.$commonFuction.isEmptyObject(this.company) ||
            this.$commonFuction.isEmpty(this.company)
          ) {
            company_add.setCustomValidity("Công ty không được để trống!");
          } else {
            company_add.setCustomValidity("");
          }
        }

        let username_add = document.getElementById("username");
        const testUsername = /^[a-z0-9_.]+$/;
        if (
          this.username == undefined ||
          this.username == null ||
          this.username == ""
        ) {
          username_add.setCustomValidity("Tên đăng nhập không được để trống!");
        } else if (!testUsername.test(this.username)){
          username_add.setCustomValidity("Tên đăng nhập không hợp lệ!");
        } else if (this.username.length > 50) {
          username_add.setCustomValidity("Tên đăng nhập không được quá 50 ký tự!");
        } else if (await this.existUsername()) {
          username_add.setCustomValidity(`Tên đăng nhập ${this.username} đã tồn tại!`);
        } else {
          username_add.setCustomValidity("");
        }
      }

      let fullname_add = document.getElementById("fullname");
      if (
        this.fullname == undefined ||
        this.fullname == null ||
        this.fullname == ""
      ) {
        fullname_add.setCustomValidity("Tên hiển thị không được để trống!");
      } else if (this.fullname.length > 255) {
        fullname_add.setCustomValidity("Tên hiển thị không được quá 255 ký tự!");
      } else {
        fullname_add.setCustomValidity("");
      }

      let phone_add = document.getElementById("phone");
      if (
        this.phone == undefined ||
        this.phone == null ||
        this.phone == ""
      ) {
        // phone_add.setCustomValidity("Số điện thoại không được để trống!");
        phone_add.setCustomValidity("");
      } else {
        if (isNaN(this.phone)) {
          phone_add.setCustomValidity("Số điện thoại không đúng định dạng!");
        } else if (this.phone.length > 15 || this.phone.length < 9) {
          phone_add.setCustomValidity("Số điện thoại không được quá 15 ký tự!");
        } else {
          phone_add.setCustomValidity("");
        }
      }

      let email_add = document.getElementById("email");
      if (
        this.email == undefined ||
        this.email == null ||
        this.email == ""
      ) {
        // email_add.setCustomValidity("Email không được để trống!");
        email_add.setCustomValidity("");
      } else if (!this.validateEmail()) {
        email_add.setCustomValidity("Email không đúng định dạng!");
      } else if (await this.existEmail()) {
        email_add.setCustomValidity(`Email ${this.email} đã tồn tại!`);
      } else {
        email_add.setCustomValidity("");
      }

      let id_card_add = document.getElementById("id_card");
      if ( this.id_card == undefined || this.id_card == null || this.id_card == "") {
        id_card_add.setCustomValidity("CCCD không được để trống!");
      } else {
        console.log(isNaN(this.id_card))
        if (isNaN(this.id_card)) {
          id_card_add.setCustomValidity("CCCD không đúng định dạng!");
        } else if (await this.existCCCD()) {
          id_card_add.setCustomValidity(`CCCD ${this.id_card} đã tồn tại!`);
        }else{
          id_card_add.setCustomValidity("");
        }
      }   

      let role_company_add = document.getElementById("role_company_add");
      if (this.$commonFuction.isEmptyObject(this.role_company)) {
        role_company_add.setCustomValidity("Vui lòng chọn quyền (role)!");
      } else {
        role_company_add.setCustomValidity("");
      }
      if(this.type_company == 'internal'){
        let department_add = document.getElementById("department");
        if (
          this.$commonFuction.isEmptyObject(this.departments) ||
          this.departments.length == 0
        ) {
          department_add.setCustomValidity("Bộ phận không được để trống!");
        } else {
          department_add.setCustomValidity("");
        }

        let position_add = document.getElementById("position");
        if (
          this.positions.length == 0 ||
          this.$commonFuction.isEmptyObject(this.positions)
        ) {
          position_add.setCustomValidity("Chức vụ không được để trống!");
        } else {
          position_add.setCustomValidity("");
        }
      }else{
        let contractor_add = document.getElementById("contractor_add");
        if (this.$commonFuction.isEmptyObject(this.selcontractor)) {
          contractor_add.setCustomValidity("Vui lòng chọn nhà thầu!");
        } else {
          contractor_add.setCustomValidity("");
        }
      }


      let password_add = document.getElementById("password");
      if (this.mode == "add") {
        if (
          this.password == undefined ||
          this.password == null ||
          this.password == ""
        ) {
          password_add.setCustomValidity("Mật khẩu không được để trống!");
        } else {
          password_add.setCustomValidity("");
        }
      }

      if (!this.$commonFuction.isEmpty(this.password)) {
        password_add.setCustomValidity(
          (await this.validatePassword()).toString()
        );
      } else if (this.mode == "edit") {
        password_add.setCustomValidity("");
      }

      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    async validatePassword() {
      if (this.password.length < 8) {
        return "Mật khẩu phải có ít nhất 8 ký tự!";
      }
      if (this.password.length > 50) {
        return "Mật khẩu không được quá 50 ký tự!";
      }
      if (!/[A-Z]/.test(this.password)) {
        return "Vui lòng nhập mật khẩu có 1 ký tự hoa + thường, 1 ký tự số, 1 ký tự đặc biệt ~!@#$%^&*()_+-=";
      }
      if (!/[a-z]/.test(this.password)) {
        return "Vui lòng nhập mật khẩu có 1 ký tự hoa + thường, 1 ký tự số, 1 ký tự đặc biệt ~!@#$%^&*()_+-=";
      }
      if (!/[0-9]/.test(this.password)) {
        return "Vui lòng nhập mật khẩu có 1 ký tự hoa + thường, 1 ký tự số, 1 ký tự đặc biệt ~!@#$%^&*()_+-=";
      }
      var re = /^(?=.*\d)(?=.*[!@#$%^&*])/;
      if (!re.test(this.password)) {
        return "Vui lòng nhập mật khẩu có 1 ký tự hoa + thường, 1 ký tự số, 1 ký tự đặc biệt ~!@#$%^&*()_+-=";
      }
      if (!((/[A-Z]/.test(this.password)) || (/[0-9]/.test(this.password)) || (re.test(this.password)) || (/[a-z]/.test(this.password))))
        return "Vui lòng nhập mật khẩu có 1 ký tự hoa + thường, 1 ký tự số, 1 ký tự đặc biệt ~!@#$%^&*()_+-="
      return "";
    },
    async existUsername() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var {data} = await ApiRepository.post("/_api/users/check_username_exist", {username: this.username, uid: this.uid}, {headers});
        var user = data.data;
        if (user.length > 0) {
          return true;
        }
        return false
      }
    },
    async existEmail() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        console.log("this.email, this.uid", this.email, this.uid)
        var {data} = await ApiRepository.post("/_api/users/check_email_exist", {email: this.email, uid: this.uid}, {headers});
        var user = data.data;
        if (user.length > 0) {
          return true;
        }
        return false
      }
    },
    async existCCCD() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var {data} = await ApiRepository.post("/_api/users/check_idcard_exist", {id_card: this.id_card, uid: this.uid}, {headers});
        var user = data.data;
        if (user.length > 0) {
          return true;
        }
        return false
      }
    },
    validateEmail() {
      var re = /\S+@\S+\.\S+/;
      return re.test(this.email);
    },
    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }
      if (Object.entries(this.validationErrors).length !== 0) {
        this.$commonFuction.is_loading(false);
      }

      if(this.type_company == 'contractor'){
        if (!this.images || this.images.length == 0) {
          alert("Vui lòng chọn Hình đại diện!");
          this.$commonFuction.is_loading(false);
          return;
        }
      }
      var birthday = null;
      if (this.birthday_1) {
        birthday = moment(this.birthday_1).toDate();
      }

      var params = {
        name: this.name,
        company: this.company,
        username: this.username,
        birthday: birthday,
        fullname: this.fullname,
        phone: this.phone,
        email: this.email,
        positions: this.positions,
        departments: this.departments,
        images: this.images,
        password: this?.password ? this.$commonFuction.hashPasswordAdmin(this.password) : null,
        active: this.active,
        role_company : this.role_company,
        contractor : this.selcontractor,
        type_company : this.type_company,
        list_profile : this.list_profile,
        files_deleted : this.filesDeletes2,
        id_card : this.id_card,
        work : this.work,
        password_text : this.password,
        manager_sel : this.selusers1,
        safety_staff_group_id : this.safety_staff_group_id,
      };
      console.log("saveData", params);
      // this.$commonFuction.is_loading(false);
      this.$emit("save", params);
    },
    isImage(file) {
      return /^image\//.test(file.type);
    },
    async onFileSelect(event) {
      let files = event.target.files || event.dataTransfer.files;
      if (files.length > 0) {
        if (files.length > 1) {
          alert("Chỉ được upload tối đa 1 ảnh");
          return;
        }
        let acceptTags = [
          "jpeg",
          "jpg",
          "gif",
          "png",
          "JPEG",
          "JPG",
          "PNG",
          "GIF",
        ];
        for (let i = 0; i < files.length; i++) {
          if (!acceptTags.includes(files[i].name.split(".").pop())) {
            alert(
              "Please upload the image file in the following format: jpeg, jpg, gif, png"
            );
            return;
          }
        }
        if (files.length + this.images.length > this.maxFiles) {
          alert("Hình ảnh quá số lượng tối đa là " + this.maxFiles + " hình");
        } else {
          var arrTemp = [],
            arrFiles = [];
          for (let file of files) {
            if (this.isImage(file) && file.size <= this.maxFileSize) {
              file.source = file;
              file.objectURL = window.URL.createObjectURL(file);
              arrTemp.push(file);
            }
            if (file.size > this.maxFileSize) arrFiles.push(file);
          }

          if (arrFiles.length > 0) {
            alert("Hình ảnh của bạn đã quá dung lượng 50MB");
          } else {
            if (this.images.length > 0 && this.images[0].file === "") {
              this.imagesDeletes.push(this.images[0]);
            }
            this.images = [];
            this.images = this.images.concat.apply(this.images, arrTemp);
          }
        }
      }
      event.target.value = "";
      return;
    },
    onFileClear(index) {
      let img = this.images[index];
      this.images.splice(index, 1);
      if (img.file === "") this.imagesDeletes.push(img);
    },
    ShowUpload(index){
      this.index_update = -1;
      const profile = this.list_profile[index];
      this.index_update = index;
      var profile_info = {
        id : profile.id,
        name : profile.name,
        expiration_date : profile.expiration_date ?? null,
        expiration_date_text : profile.expiration_date_text ?? '',
        files : profile.files ? JSON.parse(JSON.stringify(profile.files)) : [],
        document_files_users_id : profile.document_files_users_id ?? null,
        expiration_from : profile.expiration_from ?? null,
        expiration_from_text : profile.expiration_from_text ?? '',
      }
      console.log("profile_info===",profile_info)
      this.profile_info = profile_info ;
      this.filesDeletes2_tmp = []
      this.showEditDialog = true
    },
    async onFileSelect2(event) {
      let files = event.target.files || event.dataTransfer.files;
      this.loading = true;
      if (files.length > 0) {
        if (files.length > this.maxFilesProfile) {
          event.target.value = "";
          this.loading = false;
          alert("Chỉ được upload tối đa "+this.maxFilesProfile+" file");
          return;
        }
        let acceptTags = [
          "docx", "doc", "xlsx", "pptx", "pdf","xls",
          "DOCX", "DOC", "XLSX", "PPTX", "PDF","XLS",
          "png", "jpg", "jpeg", "PNG", "JPG", "JPEG",
        ];
        for (let i = 0; i < files.length; i++) {
          if (!acceptTags.includes(files[i].name.split(".").pop())) {
            event.target.value = ""
            this.loading = false;
            alert(
              "Vui lòng upload file có định dạng là: docx, doc, xlsx, pptx, pdf, png, jpg, jpeg."
            );
            return;
          }
        }
        if (files.length + this.profile_info.files.length > this.maxFilesProfile) {
          event.target.value = "";
          this.loading = false;
          alert("Số lượng tối đa là " + this.maxFilesProfile + " files");
          return;
        } else {
          var arrTemp = [],
            arrFiles = [];
          for (let file of files) {
            console.log(file.type);
            // this.isImage(file){
              if (file.size <= this.maxFileSize) {
                file.source = file;
                file.objectURL = window.URL.createObjectURL(file);
                file.is_new = true;
                arrTemp.push(file);
              }else{
                arrFiles.push(file);
              }
            // }
          }
          // console.log("arrTemp",arrTemp)
          if (arrFiles.length > 0) {
            event.target.value = "";
            this.loading = false;
            alert("File của bạn đã quá dung lượng 50MB");
            return;
          } else {
            // this.files = this.files.concat.apply(this.files, arrTemp);
            console.log("arrTemp===",arrTemp);
            var tmp_add = []
            await this.$CoreService.uploadImages(this.$constants.FOLDER_S3.DOCUMENT_FILES, arrTemp).then((resImage)=> {
              tmp_add = resImage
            })

            // for (let m = 0; m < tmp_add.length; m++) {
            //   let url = tmp_add[m].url
            //   let split = url.split('/')
            //   let fileName = split[split.length - 1]
            //   tmp_add[m].name = fileName;
            // }
            // console.log("tmp_add=========",tmp_add)
            this.profile_info.files = this.profile_info.files.concat.apply(this.profile_info.files, tmp_add);
          }
        }
      }
      // console.log("this.profile_info",this.profile_info)
      event.target.value = "";
      this.loading = false;
      return;
    },
    async EditData(){
      // console.log("this.profile_info",this.profile_info)
      // console.log("index_update",this.index_update)
      
      const tmp = this.profile_info
      // console.log("tmp===",tmp)
      tmp.expiration_date_text = tmp.expiration_date ? moment(tmp.expiration_date).format("DD/MM/YYYY") : null
      tmp.expiration_from_text = tmp.expiration_from ? moment(tmp.expiration_from).format("DD/MM/YYYY") : null
      if(this.index_update >= 0){
        this.list_profile[this.index_update] = tmp;
      }
      this.showEditDialog = false
      this.profile_info = null;
      // console.log("filesDeletes2_tmp===",this.filesDeletes2_tmp)
      this.filesDeletes2 = this.filesDeletes2.concat(this.filesDeletes2_tmp);
      // console.log("filesDeletes2===",this.filesDeletes2)
    },
    downloadFile(file) {
      const fileUrl = file ? (file.url || file.objectURL) : null;
      if (!fileUrl) return;

      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = file.name || fileUrl.split("?")[0].split("/").pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    onFileClear2(index) {
      let file = this.profile_info.files[index];
      this.profile_info.files.splice(index, 1);
      if (file && file.is_old==true) this.filesDeletes2_tmp.push(file.id);
    },
    changeType(){
      console.log("this.type_company==",this.type_company)
      if(this.type_company == 'internal'){
        this.selcontractor = null
      }else{
        this.positions = null,
        this.departments = null
      }
    },
    async getListDocumentFileAll() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        this.updateListProfile([])
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        await ApiRepository.post("/_api/document_files/all", {type : 'PERSONNEL_PROFILE' ,object_id : this.uid, company_id: this.company.id}, {headers}).then((res) => {
            var tmp_df = res.data.data.document_files ?? []
            // console.log("tmp_df===",tmp_df)
            this.updateListProfile(tmp_df)
            
        }).catch((err) => {
            console.log(err);
        })
      }
    },
    updateListProfile(list=[]){
      var tmp = []
      for (let i = 0; i < list.length; i++) {
        let files = list[i].files ?? []
        let tm = {
          id : list[i].id,
          name : list[i].name,
          document_files_users_id : list[i].document_files_users_id ?? null,
          files : files,
          expiration_date : list[i].expiration_date ? new Date(list[i].expiration_date) : null,
          expiration_date_text : list[i].expiration_date ? moment(list[i].expiration_date).format("DD/MM/YYYY") : null,
          expiration_from : list[i].expiration_from ? new Date(list[i].expiration_from) : null,
          expiration_from_text : list[i].expiration_from ? moment(list[i].expiration_from).format("DD/MM/YYYY") : null,
        }
        tmp.push(tm)
      }
      // console.log("tmp==",tmp[0])
      this.list_profile = tmp
    },
    async getListCourse(id){
      if (this.$commonFuction.isEmptyObject(this.company)) {
        this.updateListCourse([])
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        await ApiRepository.post("/_api/users/list_course", {id : id, company_id: this.company.id}, {headers}).then((res) => {
            var tmp_df = res.data.data ?? []
            console.log("tmp_df===",tmp_df)
            this.updateListCourse(tmp_df)
            
        }).catch((err) => {
            console.log(err);
        })
      }
    },
    updateListCourse(data=[]){
      var tmp = []
      if(data.length > 0){
        for (let i = 0; i < data.length; i++) {
          var course_name = ''
          var sra_name = ''
          var kq_text = ''
          var time_exp = ''
          var type_text = ''
          if(data[i].course){
            course_name = data[i].course.name ?? ''
            if(data[i].course.type == 'online'){
              type_text = 'Online'
            }else{
              type_text = 'Offline'
            }
          }
          if(data[i].sra){
            sra_name = data[i].sra.name ?? ''
          }
          if(data[i].course_lesson){
            time_exp = data[i].course_lesson.expired_date ? moment(data[i].course_lesson.expired_date).format("DD/MM/YYYY HH:mm") : ''
          }
          if(data[i].status == 'PASS'){
            kq_text = 'Đạt'
          }else if(data[i].status == 'FAILED'){
            kq_text = 'Chưa đạt'
          }
          let tm = {
            id : data[i].id,
            course_name : course_name,
            type_text : type_text,
            sra_name : sra_name,
            kq_text : kq_text,
            time_exp : time_exp,
          }
          tmp.push(tm)
        }
      }
      this.list_course = tmp
    },
    async removeDepartments(index){
      this.departments.splice(index, 1)
    },
    async removePositions(index){
      this.positions.splice(index, 1)
    },
    async viewFile(file) {
      const fileUrl = file ? (file.url || file.objectURL) : null;
      if (!fileUrl) return;

      const fileName = file.name || fileUrl.split("?")[0].split("/").pop() || "";
      const extension = fileName.toLowerCase().split(".").pop();
      const imageMimeTypes = {
        jpg: "image/jpeg", jpeg: "image/jpeg", png: "image/png",
        gif: "image/gif", webp: "image/webp", bmp: "image/bmp",
        svg: "image/svg+xml", tif: "image/tiff", tiff: "image/tiff",
      };
      const isPdf = extension === "pdf";
      const isImage = Object.prototype.hasOwnProperty.call(imageMimeTypes, extension);

      if (!isPdf && !isImage) {
        window.open(fileUrl, "_blank", "noopener,noreferrer");
        return;
      }

      const previewWindow = window.open("", "_blank");
      if (!previewWindow) {
        alert("Vui lòng cho phép trình duyệt mở cửa sổ mới để xem file.");
        return;
      }

      previewWindow.opener = null;

      try {
        const response = await fetch(fileUrl);
        if (!response.ok) throw new Error(`Không thể tải file (${response.status})`);

        const blob = await response.blob();
        const previewMimeType = isPdf ? "application/pdf" : imageMimeTypes[extension];
        const previewBlob = blob.type === previewMimeType
          ? blob
          : new Blob([blob], { type: previewMimeType });
        const blobUrl = URL.createObjectURL(previewBlob);

        previewWindow.location.href = blobUrl;
        const cleanupInterval = window.setInterval(() => {
          if (previewWindow.closed) {
            window.clearInterval(cleanupInterval);
            URL.revokeObjectURL(blobUrl);
          }
        }, 5 * 1000);
      } catch (e) {
        previewWindow.close();
        console.error("Lỗi xem file:", e);
        alert("Không thể mở file. Máy chủ lưu file có thể chưa cho phép truy cập CORS.");
      }
    },
    showContent(index){
        this.currentTab = index
    },
    emitEventUsers1(keyword) {
      // console.log(keyword);
      this.$delete(this.users1_obj.filters, 'name');
      if (keyword) {
        this.users1_obj.filters.name = keyword;
      }
      this.getListUsers1();
    },
    changeOffsetUsers1(value) {
      this.users1_obj.offset = value;
    },
    async getListUsers1() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.users1_obj.loading = true;
        await ApiRepository.post("/_api/users/options", {filters: this.users1_obj.filters, limit: this.users1_obj.limit, offset: this.users1_obj.offset, company_id: this.company.id, type_company : 'internal', approve_sra : true}, {headers}).then((res) => {
            var tmp = res.data.data?.list
            for (let i = 0; i < tmp.length; i++) {
              tmp[i].name = tmp[i].fullname 
            }
            if (this.users1_obj.offset > 0 ) {
              this.users1_obj.items.push(...tmp);
            } else{
              this.users1_obj.items = tmp;
            }
            
            this.users1_obj.total = res.data.data.count;
            this.users1_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.users1_obj.loading = false;
        })
      }
    },
    async LoadModuleUser(){
      if (this.$commonFuction.isEmptyObject(this.company)) {
        this.showCurrentTab([])
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var company_modules = await ApiRepository.post(Constants.API.MODULE_COMPANY, {company_id: this.company.id}, {headers}).then(function (response) {
            var data = response?.data?.data ?? [];
            // console.log('data module', data);
            return data
        }).catch(function (error) {
            console.log('error', error);
            return []
        });
        console.log("company_modules==", company_modules);
        this.showCurrentTab(company_modules);
      }
    },
    showCurrentTab(modules=[]){
      var hideTab = 1
      for (let i = 0; i < modules.length; i++) {
        //nếu is_approved = true và _key in ["training_management","equipment_management","health_management","environment_management","observe_safety"]
        if (modules[i].is_approved == true && ["training_management","equipment_management","health_management","environment_management","observe_safety"].includes(modules[i]._key)) {
          hideTab = 0
          break;
        }
      }
      console.log("hideTab===",hideTab)
      this.hideTab = hideTab
    },
    async SafetyStaffGroup(){
      var safety_staff_group_list = await ApiRepository.post(Constants.API.SAFETY_STAFF_GROUP_LIST).then(function (response) {
          // console.log('data module===', response?.data);
          var data = response?.data?.data ?? [];
          // console.log('data module', data);
          return data.list
      }).catch(function (error) {
          console.log('error', error);
          return []
      });
      this.safety_staff_group_list = safety_staff_group_list;
    },
    sortByOrdinalAsc(arr = []) {
      return [...arr].sort(
        (a, b) => Number(a?.ordinal ?? 0) - Number(b?.ordinal ?? 0)
      )
    }
  },
};
</script>

<style lang="scss">
label {
  font-weight: bold;
}
.button-clear {
  position: absolute;
  background-color: red;
  border-radius: 50%;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  cursor: pointer;
}
.item-img {
  width: 80px;
  height: 80px;
  position: relative;
  padding: 0;
}
.p-password .pi.pi-eye {
  color: #000;
  font-size: 14px;
}
.p-checkbox {
  margin-right: 1rem !important;
}
#customers {
  border-collapse: collapse;
  width: 100%;
}
.f-grid {
  display: flex;
  justify-content: space-between;
  margin-left: -1rem;
  flex-flow: row wrap;
}
.f-grid-col {
  flex: 1 0;
  /* background-color: #EEEEEE; */
  padding: 0rem 1rem 0rem 1rem;
  border-radius: 5px;
}
.cs-width {
  width : 100% !important;
}
.cs-input {
  width : 100%;
  /* max-width: 400px !important; */
}
.title-css { 
  font-weight: bold;
}
.radio-group {
  display: flex; /* Sử dụng flexbox để đặt chúng cùng hàng */
  gap: 40px; /* Khoảng cách giữa các radio button */
}
#tb_level {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}
#tb_level td, #customers th {
  border: 1px solid #ddd;
  padding: 6px;
}
#tb_level th {
  border: 1px solid #ddd;
  padding-top: 6px;
  padding-bottom: 6px;
  text-align: left;
  padding-left: 5px;
}
.p-button-cancel-2 {
  color : #333333;
  background-color : #F2F3F7;
  border: 1px solid #F2F3F7;
}
.profile-file-list {
  display: flex;
  min-width: 0;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}
.profile-file-row {
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 4px;
}
.profile-file-link {
  display: block;
  max-width: 100%;
  color: #0086C4;
  text-decoration: underline;
  overflow-wrap: anywhere;
  cursor: pointer;
}
.input_tmp_validator_r {
  display : block;
  width: 0px !important;
  height: 0px !important;
  background-color: #ffffff;
  border: unset;
  outline: unset;
  left: 1em;
}
#tb_course {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}
#tb_course td, #tb_course th {
  border: 1px solid #ddd;
  padding: 6px;
  padding-left: 5px !important;
  text-align: left !important;
}
#tb_course th {
  border: 1px solid #ddd;
  padding-top: 6px;
  padding-bottom: 6px;
  text-align: left;
  /* padding-left: 5px; */
}
.cus-tags{
  border-radius: 10px;
  padding: 8px;
  margin-right: 8px;
  background-color:#F2F3F7;
}
.cs-tag {
  padding: 10px 12px 10px 0px;
  font-weight: normal;
}
.cs-icon {
  color : #666666;
  padding-right: 4px;
  cursor: pointer;
}.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 5px solid #ccc;
  border-top: 5px solid #42b983;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 10px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.tab {
    display: flex;
    font-weight: 700;
    border-bottom: 1px solid #00000029;
}
.tab div {
    padding: 6px 8px;
    /* margin-right: 2px; */
    cursor: pointer;
}
.tab div.active {
    background-color: #fff;
    color: #0086C4;
    border-left: 1px solid #0086C4;
    border-right: 1px solid #0086C4;
    border-bottom: 3px solid #0086C4;
    border-top: 1px solid #0086C4;
}
.content {
    padding-top: 10px;
    display: none;
}
.content.active {
    display: block;
}
.hide-tab {
    display: none;
}
</style>
